import Table from "./Table";

export default Table;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Table/index.js